import { render } from "./SelfAssessmentV2Question.vue?vue&type=template&id=0f19080a&scoped=true"
import script from "./SelfAssessmentV2Question.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Question.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Question.vue?vue&type=style&index=0&id=0f19080a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f19080a"]])

export default __exports__